import React, { useEffect } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setFilters } from '../../../App/Slices/RunTests';
import { InputText } from 'primereact/inputtext';

export default function Filters({
  data,
  implementedComponents,
  onChange,
  urlFilterValue,
  setUrlFilterValue,
}) {
  const filters = useSelector((state) => state.runTests.filters);

  const dispatch = useDispatch();
  // Array of classes corresponding to each filter's layout
  const filterClasses = ['col-3', 'col-3', 'col-6', 'col-3', 'col-3', 'col-6'];

  useEffect(() => {
    if (!data || !data.length) return;

    //IMPORTANT: The order of this array should correspond to the level of the data in the tree
    //Example: application is the root, client is the child of application, template is the child of client, etc.
    const filterData = [
      new Set(), // application
      new Set(), // client
      new Set(), // template
      new Set(), // siteEdition
      new Set(), // url
    ];
    //This is a set of all components that are found at the URL level
    let components = new Set(implementedComponents.filter((c) => c !== ''));

    const dfs = (node, depth = 0) => {
      filterData[depth].add(node.data);
      if (node.children) {
        node.children.forEach((child) => dfs(child, depth + 1));
      }
    };

    // Start DFS from each root node
    data.forEach((node) => dfs(node));

    filterData.push(components); //Add the components to the filterData array

    // Update filters with the collected data
    dispatch(
      setFilters(
        filters.map((filter, index) => ({
          ...filter,
          data: Array.from(filterData[index]).sort(),
        }))
      )
    );
  }, [data, implementedComponents]);

  const handleFilterChange = (value, filterName) => {
    const updatedFilters = filters.map((filter) =>
      filter.name === filterName ? { ...filter, value } : filter
    );

    dispatch(setFilters(updatedFilters));

    if (onChange) {
      onChange(updatedFilters);
    }
  };

  return (
    <div className='filters-container p-4'>
      {/* First row */}
      <div className='' style={{ display: 'flex' }}>
        {filters.slice(0, 3).map((filter, index) => (
          <div key={filter.name} className={filterClasses[index]}>
            <MultiSelect
              value={filter.value}
              options={
                filter.data?.map((item) => ({
                  label: item,
                  value: item,
                })) || []
              }
              closeIcon={false}
              onChange={(e) => handleFilterChange(e.value, filter.name)}
              placeholder={`Select ${filter.name}`}
              style={{ width: '100%' }}
              className='w-full'
              filter
              filterPlaceholder='Search'
              filterBy='label'
            />
          </div>
        ))}
      </div>

      {/* Second row */}
      <div className='' style={{ display: 'flex' }}>
        {filters.slice(3).map((filter, index) => (
          <div key={filter.name} className={filterClasses[index + 3]}>
            {filter.name === 'url' ? (
              <InputText
                // value={filter.value || ''}
                // onChange={(e) =>
                //   handleFilterChange(e.target.value, filter.name)
                // }
                value={urlFilterValue || ''}
                onChange={(e) => setUrlFilterValue(e.target.value)}
                placeholder='Filter by URL'
                style={{ width: '100%' }}
                className='w-full'
              />
            ) : (
              <MultiSelect
                value={filter.value}
                options={
                  filter.data?.map((item) => ({
                    label: item,
                    value: item,
                  })) || []
                }
                onChange={(e) => handleFilterChange(e.value, filter.name)}
                placeholder={`Select ${filter.name}`}
                style={{ width: '100%' }}
                className='w-full'
                filter
                filterPlaceholder='Search'
                filterBy='label'
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
